<template>
  <div class="mt-3">
    <div class="flex justify-center px-1 py-3">
      <button
        @click="openDialog"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 border border-transparent text-xs font-medium rounded-full text-app-primary bg-app-primary/5 hover:bg-app-primary/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-app-primary ml-2 transition-colors"
      >
        <UserGroupIcon class="h-3.5 w-3.5" aria-hidden="true" />
        See All Team Members
      </button>
    </div>

    <GlobalDialog
      v-model="dialog"
      dialogDefaultSize="40%"
      title="Team Members"
      :showActionButton="false"
    >
      <template #content>
        <div class="relative mt-2 p-2 px-5">
          <div
            class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-7"
          >
            <SearchIcon
              class="inline h-4 w-4 text-untitled-gray-400"
              aria-hidden="false"
            />
          </div>
          <input
            id="Groups-Page-Search-field"
            name="search"
            class="block w-full appearance-none rounded-lg border border-untitled-gray-300 px-3 py-2.5 placeholder-untitled-gray-400 shadow-sm focus:border-app-primary focus:outline-none focus:ring-1 focus:ring-app-primary sm:text-sm pl-10"
            placeholder="Type to search members."
            type="search"
            v-model="search"
            :disabled="loadingUsers"
          />
        </div>
        <div class="mt-3 px-5">
          <div v-if="!records.length && !loadingUsers">
            <div class="flex flex-col justify-center items-center content-center py-16 text-center">
              <div class="flex items-center justify-center h-12 w-12 rounded-full bg-app-primary/10 mb-3">
                <UserGroupIcon class="h-6 w-6 text-app-primary" aria-hidden="true" />
              </div>
              <h3 class="text-sm font-medium text-untitled-gray-900">No members found</h3>
              <p class="text-xs text-untitled-gray-400 mt-1">Try a different search term.</p>
            </div>
          </div>
          <div v-if="loadingUsers" class="p-3">
            <el-skeleton :rows="7" animated  />
          </div>
          <ul
            role="list"
            class="space-y-2 py-2"
            @scroll="onScroll"
            style="height: 500px; overflow: auto"
            v-else
          >
            <li
              v-for="row in records"
              :key="row.id"
              class="flex items-center space-x-3 p-3 rounded-xl border border-transparent hover:border-app-secondary/30 hover:bg-app-primary/5 transition-colors"
            >
              <div class="flex-1 min-w-0">
                <p
                  class="text-sm font-medium text-untitled-gray-900 truncate"
                  :id="`Group-Members-List-Modal-list-${row.id}`"
                >
                  {{ row.name }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </GlobalDialog>
  </div>
</template>

<script setup>
import { SearchIcon, UserGroupIcon } from "@heroicons/vue/solid";
import { getUsers } from "@/composable/users/getUsers";
import { debounce as _debounce } from "lodash-es";
import { ref, watch } from "vue";
import GlobalDialog from "../layout/GlobalDialog.vue";
import { ElSkeleton } from 'element-plus'

const { userList, users, loadingUsers } = getUsers();

const search = ref("");
const dialog = ref(false);
const records = ref([])

const openDialog = async () => {
  dialog.value = true
  await userList()
  records.value = users.value
}

const searchUsers = _debounce(async (value) => {
   if(!value.length){
    records.value = users.value

    return
   }

   records.value = users.value.filter((user) => {
    return user.name.toLowerCase().includes(value.toLowerCase())
   })


}, 600);

watch(search, function (value) {
  searchUsers(value);
});
</script>
